// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from './application';

import AppleLoginController from './apple_login_controller.ts';
application.register('apple-login', AppleLoginController);

import AutogrowController from './autogrow_controller.ts';
application.register('autogrow', AutogrowController);

import AutosubmittingController from './autosubmitting_controller.ts';
application.register('autosubmitting', AutosubmittingController);

import ContinueButtonController from './continue_button_controller.ts';
application.register('continue-button', ContinueButtonController);

import DelayedClickController from './delayed_click_controller.ts';
application.register('delayed-click', DelayedClickController);

import ExerciseController from './exercise_controller.ts';
application.register('exercise', ExerciseController);

import FilterController from './filter_controller.ts';
application.register('filter', FilterController);

import LengthCounterController from './length_counter_controller.ts';
application.register('length-counter', LengthCounterController);

import NavbarButtonController from './navbar_button_controller.ts';
application.register('navbar-button', NavbarButtonController);

import MessagesController from './messages_controller.ts';
application.register('messages', MessagesController);

import PhoneController from './phone_controller.ts';
application.register('phone', PhoneController);

import PurchaseController from './purchase_controller.ts';
application.register('purchase', PurchaseController);

import PushController from './push_controller.ts';
application.register('push', PushController);

import ShareController from './share_controller.ts';
application.register('share', ShareController);

import SliderController from './slider_controller.ts';
application.register('slider', SliderController);

import TrackingController from './tracking_controller.ts';
application.register('tracking', TrackingController);

import VideoController from './video_controller.ts';
application.register('video', VideoController);
